module.exports = __webpack_public_path__ + "static/media/announcement-label-icon.57a2548c.svg";